import Transformer from "./transformer";
import { assetURL } from "@/utils";

import moment from "moment";

export default class InvoiceTransformer extends Transformer {
  static fetch(invoice) {
    const sinisters = (invoice.sinisters || []).map((s) => ({
      ...s,
      id: s.id,
      sinisterNumber: s.sinister_number,
    }));

    return {
      id: invoice.id,
      uuid: invoice.uuid,
      serie: invoice.serie,
      folio: invoice.folio,
      cfdiType: invoice.cfdi_type,
      version: invoice.version,
      status: (invoice.state && invoice.state.name) || invoice.state,
      statusId: invoice.state && invoice.state.id,
      sender: invoice.sender,
      receiver: invoice.receiver,
      customer: invoice.customer || {},

      invoicedDates: {
        chargedDate: invoice.add_date,
        addDate: invoice.date,
      },

      chargedDate: moment(invoice.add_date),
      addDate: moment(invoice.date),

      currency: {
        alterName: invoice.currency.alternative_name,
        codeName: invoice.currency.codename,
        name: invoice.currency.name,
      },
      receiver: invoice.receiver
        ? {
            businessName: invoice.receiver.business_name,
            id: invoice.receiver.id,
            rfc: invoice.receiver.rfc,
            paymentMethodId: invoice.receiver.payment_method,
          }
        : {},
      sender: invoice.sender
        ? {
            account: invoice.sender.account,
            businessName: invoice.sender.business_name,
            rfc: invoice.sender.rfc,
          }
        : {},

      amounts: {
        subtotal: invoice.subtotal,
        total: invoice.total,
      },

      subtotal: +invoice.subtotal,
      total: +invoice.total,
      exchangeRate: invoice.exchange_rate,
      discount: invoice.discount,
      vat: invoice.vat,

      xmlFile: invoice.xml_file,
      pdfFile: invoice.pdf_file,
      proofCancellation: invoice.proof_cancellation,
      cancellationRequest:
        (invoice.cancellation_request[0] &&
          invoice.cancellation_request[0].cancellation_request_file) ||
        null,
      cancellationRequestID:
        (invoice.cancellation_request[0] &&
          invoice.cancellation_request[0].id) ||
        null,
      confirmRequestCancellation:
        (invoice.cancellation_request[0] &&
          invoice.cancellation_request[0].cancellation_confirmation_file) ||
        null,
      reinvoicingRequest:
        (invoice.reinvoices_request[0] &&
          invoice.reinvoices_request[0].reinvoice_request_file) ||
        null,
      cancellationFile:
        (invoice.cancellation_request[0] &&
          invoice.cancellation_request[0].cfdi_cancellation &&
          invoice.cancellation_request[0].cfdi_cancellation
            .pdf_proof_payment) ||
        null,
      zipFile: invoice.zip_file,

      isCharged: invoice.is_charged,

      isReceived: invoice.is_received,
      isCancelled: invoice.is_cancelled,
      cancellationDate: invoice.cancellation_date,
      cancellationDateSign:
        (invoice.cancellation_request[0] &&
          invoice.cancellation_request[0].cfdi_cancellation &&
          invoice.cancellation_request[0].cfdi_cancellation
            .cancellation_date) ||
        null,
      isActive: invoice.is_active,
      currency: invoice.currency,

      sinisters,
      requisitionNumbers: invoice.affecteds.map((a) => a.requisition_number),
    };
  }
}



// WEBPACK FOOTER //
// ./src/transformers/Invoice.js